(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comparison-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupCarousel = (root) => {
      if (!root || root.dataset.comparisonReady === 'true') return;

      const viewport = root.querySelector('[data-comparison-viewport]');
      const track = root.querySelector('[data-comparison-track]');
      const arrows = root.querySelectorAll('[data-comparison-direction]');

      if (!viewport || !track) return;

      root.dataset.comparisonReady = 'true';

      const getStep = () => {
        const card = track.querySelector('.product-comparison__card');
        if (!card) return viewport.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateArrows = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        arrows.forEach((arrow) => {
          const direction = Number(arrow.dataset.comparisonDirection);
          arrow.disabled = direction < 0
            ? viewport.scrollLeft <= 2
            : viewport.scrollLeft >= maxScroll - 2;
        });
      };

      const syncRowHeights = () => {
        const rows = [1, 2, 3];

        rows.forEach((row) => {
          root.style.removeProperty(`--pc-row-${row}-height`);
        });

        rows.forEach((row) => {
          const cells = root.querySelectorAll(`[data-comparison-row="${row}"]`);
          const height = Math.max(...Array.from(cells, (cell) => {
            const cellStyles = window.getComputedStyle(cell);
            const label = cell.querySelector('.product-comparison__label');
            const value = cell.querySelector('.product-comparison__value');
            const labelStyles = label ? window.getComputedStyle(label) : null;
            const verticalSpacing =
              parseFloat(cellStyles.paddingTop) +
              parseFloat(cellStyles.paddingBottom) +
              parseFloat(cellStyles.borderTopWidth) +
              parseFloat(cellStyles.borderBottomWidth);
            const labelHeight = label ? label.scrollHeight : 0;
            const labelMargin = labelStyles ? parseFloat(labelStyles.marginBottom) : 0;
            const valueHeight = value ? value.scrollHeight : 0;

            return verticalSpacing + labelHeight + labelMargin + valueHeight;
          }));

          if (Number.isFinite(height)) {
            root.style.setProperty(`--pc-row-${row}-height`, `${Math.ceil(height)}px`);
          }
        });
      };

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const direction = Number(arrow.dataset.comparisonDirection);
          viewport.scrollBy({
            left: getStep() * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      });

      let pointerIsDown = false;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let dragMoved = false;

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target instanceof Element && event.target.closest('a, button')) return;

        pointerIsDown = true;
        dragMoved = false;
        pointerStartX = event.clientX;
        pointerStartScroll = viewport.scrollLeft;
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!pointerIsDown) return;

        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 4) dragMoved = true;
        viewport.scrollLeft = pointerStartScroll - distance;
      });

      const releasePointer = (event) => {
        if (!pointerIsDown) return;

        pointerIsDown = false;
        if (viewport.hasPointerCapture(event.pointerId)) {
          viewport.releasePointerCapture(event.pointerId);
        }
        viewport.classList.remove('is-dragging');
        updateArrows();
      };

      viewport.addEventListener('pointerup', releasePointer);
      viewport.addEventListener('pointercancel', releasePointer);
      viewport.addEventListener('dragstart', (event) => event.preventDefault());
      viewport.addEventListener('click', (event) => {
        if (!dragMoved) return;

        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      let frame;
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateArrows);
      }, { passive: true });

      let resizeFrame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          syncRowHeights();
          updateArrows();
        });
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncRowHeights);
      }

      new ResizeObserver(updateArrows).observe(viewport);
      syncRowHeights();
      updateArrows();
    };

    document.querySelectorAll('[data-product-comparison]').forEach(setupCarousel);

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-product-comparison]')
        ? event.target
        : event.target.querySelector('[data-product-comparison]');
      setupCarousel(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-hair-calendar-waitlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCountdowns = (root = document) => {
      root.querySelectorAll('[data-calendar-countdown]').forEach((countdown) => {
        if (countdown.dataset.countdownInitialized === 'true') return;

        const launchTime = new Date(countdown.dataset.launchAt).getTime();
        const units = countdown.querySelector('[data-countdown-units]');
        const completeMessage = countdown.querySelector('[data-countdown-complete]');
        const fields = {
          days: countdown.querySelector('[data-countdown-days]'),
          hours: countdown.querySelector('[data-countdown-hours]'),
          minutes: countdown.querySelector('[data-countdown-minutes]'),
          seconds: countdown.querySelector('[data-countdown-seconds]')
        };

        if (Number.isNaN(launchTime)) {
          countdown.hidden = true;
          return;
        }

        countdown.dataset.countdownInitialized = 'true';
        let countdownTimer;

        const updateCountdown = () => {
          const remaining = launchTime - Date.now();

          if (remaining <= 0) {
            units.hidden = true;
            completeMessage.hidden = false;
            window.clearInterval(countdownTimer);
            return;
          }

          fields.days.textContent = Math.floor(remaining / 86400000);
          fields.hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
          fields.minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
          fields.seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        };

        updateCountdown();
        if (!units.hidden) {
          countdownTimer = window.setInterval(updateCountdown, 1000);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCountdowns());
    } else {
      initializeCountdowns();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCountdowns(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
